import keys from "lodash/keys";

const STORAGE_KEY = "profinda_custom_configuration";

// customizeConfig let you overwrite default window.PF.config with localStorage.
// usage (enable):
//    window.PF.Initializers.customizeConfig({api_endpoint: "https://profinda-staging-pr-99999.multi.profinda-staging.com"})
// usage (disable):
//    window.PF.Initializers.customizeConfig()
// and then refresh
export const customizeConfig = (customConfig: Record<string, any>) => {
  // avoid a common issue of trailing "/" when copy-pasting api_endpoint
  if (customConfig?.api_endpoint) {
    customConfig.api_endpoint = customConfig.api_endpoint.replace(/\/$/, "");
  }

  if (keys(customConfig).length === 0) {
    return window.storage.removeItem(STORAGE_KEY);
  } else {
    return window.storage.setItem(STORAGE_KEY, customConfig);
  }
};
